import { supabase } from './client';

// ========================
// AUTH / SESIÓN (AuthContext)
// ========================

export async function getAuthProfileById(userId) {
  return supabase
    .from('profiles')
    .select('*')
    .eq('id', userId)
    .maybeSingle();
}

export async function callGetUserRoles(userUuid) {
  return supabase.rpc('get_user_roles', { user_uuid: userUuid });
}

export async function callGetUserMaxLevel(userUuid) {
  return supabase.rpc('get_user_max_level', { user_uuid: userUuid });
}

// ========================
// PERMISOS (PermissionsContext)
// ========================

export async function callGetUserPermissions(userUuid) {
  return supabase.rpc('get_user_permissions', { user_uuid: userUuid });
}

export async function getActiveUserRoleIds(userId) {
  return supabase
    .from('user_roles')
    .select('role_id')
    .eq('user_id', userId)
    .eq('is_active', true);
}

export async function getRolePermissionsByRoleIds(roleIds) {
  return supabase
    .from('role_permissions')
    .select('permissions(id, code, description)')
    .in('role_id', roleIds);
}

// ========================
// ONBOARDING (OnboardingModal)
// ========================

export async function completeOnboardingProfile(userId, { name, phone, role }) {
  return supabase
    .from('profiles')
    .update({
      name,
      phone,
      role,
      onboarding_complete: true,
    })
    .eq('id', userId);
}

// ========================
// PERFIL DE USUARIO (ProfilePage)
// ========================

export async function updateProfileContactInfo(userId, { name, phone }) {
  return supabase
    .from('profiles')
    .update({ name, phone })
    .eq('id', userId);
}

// ========================
// NOTIFICACIONES PUSH (NotificationManager)
// ========================

export async function upsertPushSubscription(userId, subscriptionJson, deviceType) {
  return supabase
    .from('push_subscriptions')
    .upsert(
      {
        user_id: userId,
        subscription_json: subscriptionJson,
        device_type: deviceType,
      },
      { onConflict: 'user_id, subscription_json' }
    );
}

export async function deletePushSubscription(userId, subscriptionJson) {
  return supabase
    .from('push_subscriptions')
    .delete()
    .eq('user_id', userId)
    .contains('subscription_json', subscriptionJson);
}
